/* eslint-disable */

import * as clientService from "../services/httpsClient";
import dayjs from "dayjs";

export const getCompanies = async (accessToken, params) => {
  try {
    const domain = `companies`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCompany = async (accessToken, params) => {
  // const { page, limit, values, is_superuser, company_id, sale_id } = params;
  // let object = {
  //   page: page ? page : 0,
  //   limit: limit ? limit : 10,
  //   company_code: values ? values.company_code : undefined,
  //   company_name: values ? values.company_name : undefined,
  //   telephone: values ? values.telephone : undefined,
  //   is_credit: values ? values.is_credit : "All",
  //   is_superuser: is_superuser ? is_superuser : false,
  //   company_id: company_id ? company_id : undefined,
  //   sale_id: sale_id ? sale_id : undefined,
  // };

  // object.start_date = values?.start_date ? values.start_date : undefined;
  // object.end_date = values?.end_date ? values.end_date : undefined;
  try {
    const domain = `companies`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportCompany = async (accessToken, params) => {
  const { page, limit, start_date, end_date } = params;
  try {
    const domain = `companies/export-excel`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCompanysList = async (accessToken, params) => {
  try {
    const domain = `companies/listcompany`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCompanyById = async (accessToken, id, params) => {
  try {
    const domain = `companies/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createCompany = async (accessToken, body) => {
  try {
    const domain = `companies`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompany = async (accessToken, body) => {
  try {
    const domain = `companies`;
    return await clientService.putApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompany = async (accessToken, body) => {
  try {
    const domain = `companies`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyRoutes = async (accessToken, id, body) => {
  try {
    const domain = `companyroute/${id}`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCompanyRoutes = async (accessToken, body) => {
  try {
    const domain = `companyroute`;
    return await clientService.postApiRoute(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyRoutes = async (accessToken, body) => {
  try {
    const domain = `companyroute`;
    return await clientService.putApiRoute(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyRoutes = async (accessToken, body) => {
  try {
    const domain = `companyroute`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyWareHouseRoutes = async (accessToken, body) => {
  try {
    const domain = `warehouses`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyFormula = async (accessToken, id, body) => {
  try {
    const domain = `companyformula/${id}`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyFormula = async (accessToken, body) => {
  try {
    const domain = `companyformula`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyFormula = async (accessToken, body) => {
  try {
    const domain = `companyformula`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanySales = async (accessToken, id, params) => {
  const { page, limit, company_id } = params;
  let object = {
    page: page,
    limit: limit,
    company_id: company_id ? company_id : undefined,
  };
  try {
    const domain = `companysale`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const createCompanySale = async (accessToken, body) => {
  try {
    const domain = `companysale`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanySale = async (accessToken, body) => {
  try {
    const domain = `companysale`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanySale = async (accessToken, body) => {
  try {
    const domain = `companysale`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBanner = async (accessToken, params) => {
  try {
    const domain = `companybanner`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createCompanyBanner = async (accessToken, body) => {
  try {
    const domain = `companybanner`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyBanner = async (accessToken, body) => {
  try {
    const domain = `companybanner`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyNews = async (accessToken, body) => {
  try {
    const domain = `companynews`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCompanyNews = async (accessToken, body) => {
  try {
    const domain = `companynews`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyNews = async (accessToken, body) => {
  try {
    const domain = `companynews`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyNews = async (accessToken, body) => {
  try {
    const domain = `companynews`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyImage = async (accessToken, body) => {
  try {
    const domain = `companies/companyImage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
export const deleteCompanyBillImage = async (accessToken, body) => {
  try {
    const domain = `companybillimage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerBillImage = async (accessToken, body) => {
  try {
    const domain = `customerbillimage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyStatus = async (accessToken, body) => {
  try {
    const domain = `companies/update-status-company`;
    return await clientService.updateApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyLineById = async (accessToken, id, body) => {
  try {
    const domain = `companyline/${id}`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCompanyLine = async (accessToken, body) => {
  try {
    const domain = `companyline`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyLine = async (accessToken, body) => {
  try {
    const domain = `companyline`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
